import { createReducer, on } from '@ngrx/store';
import * as HomeFeedActions from './home-feed.actions';
import { HomeFeedState, HomeFeedSection } from './home-feed.model';

const initialState: HomeFeedState = {
  sections: {
    [HomeFeedSection.URGENT_NOTIFICATIONS]: [],
    [HomeFeedSection.PROMOTION]: [],
    [HomeFeedSection.ACTIONS]: [],
    [HomeFeedSection.PROGRAMS]: [],
    [HomeFeedSection.FINDMONEY]: [],
    [HomeFeedSection.MYMONEYINFO]: [],
    [HomeFeedSection.MYMONEYCOMPLETE]: [],
    [HomeFeedSection.MYMONEYINITIAL]: [],
    [HomeFeedSection.MYMONEYHELP]: [],
    [HomeFeedSection.PAYDAY]: [],
    [HomeFeedSection.REPAYMENTS]: [],
  },
  components: {}
};

export const homeFeedReducer = createReducer(
  initialState,
  on(HomeFeedActions.registerHomeFeedCard, (state, { key, component, data, order, section }) => {
    const updatedSection = [...state.sections[section]];
    const existingIndex = updatedSection.findIndex(card => card.key === key);

    if (existingIndex !== -1) {
      updatedSection[existingIndex] = { key, component, data, order };
    } else {
      updatedSection.push({ key, component, data, order });
    }

    return {
      ...state,
      sections: {
        ...state.sections,
        [section]: updatedSection.sort((a, b) => a.order - b.order)
      }
    };
  }),
  on(HomeFeedActions.removeHomeFeedCard, (state, { key, section }) => {
    // Filter out the card from the section
    const updatedSection = state.sections[section].filter(card => card.key !== key);
    const newState = {
      ...state,
      sections: {
        ...state.sections,
        [section]: [...updatedSection], // ✅ Ensures a NEW array is assigned
      },
    };
    return {
      ...state,
      sections: {
        ...state.sections,
        [section]: [...updatedSection], // ✅ Ensures a NEW array is assigned
      },
    };
  })
);

